<script lang="ts">
    import ProgressBar from "./ProgressBar.svelte";
    import { Asset } from "@lernetz/svelte-image";
    import { flinkGateway, requests, setupSharedProps, sharedProps } from "../services";
    import { get } from "svelte/store";

    export let model;
    export let index:number;

    let cover = get(model).metadata.cover
    let imgUrl:string = undefined;

    setupSharedProps();

    if(cover != undefined) {
        imgUrl = sharedProps.flinkUrl + "/assets/convert/" + $cover.file + "/focusOffsetX=" + $cover.focus.x + "&focusOffsetY=" + $cover.focus.y + "/card-300.webp";
    }

</script>

<div class:hidden={index >= 1} class:sm:block={index == 1} class:lg:block={index == 2}>
  <a href="{$model.metadata.link}" class="h-[300px] rounded-2xl flex flex-col transition-all duration-200 shadow-md hover:-translate-y-4 hover:shadow-2xl overflow-hidden relative" target="_blank">
    <ProgressBar progress="{$model.value}" backgroundColor={"light-grey"} class="absolute bottom-16 left-16 right-16" />

    <div class="relative w-full aspect-[20/13] overflow-hidden" style:background-color={$model.metadata.color}>
      {#if cover != undefined}
          <img src={imgUrl} alt=""/>
      {/if}
    </div>
    <div class="h-8" style:background-color={$model.metadata.color}></div>
    <div class="p-16 min-h-[150px]">
        <span class="text-almost-black text-14 font-bold text-ellipsis overflow-hidden">{$model.metadata.title}</span>
    </div>
  </a>

</div>

